// extracted by mini-css-extract-plugin
export default {"groupDetailHeader":"group-header_groupDetailHeader__HdRpA","groupDetailActionRow":"group-header_groupDetailActionRow__4MCV5"};